import React, { useEffect, useRef, useState } from "react";
import CurrencyInput from "react-currency-input";
import Popper from "@mui/material/Popper";
import { useDispatch, useSelector } from "react-redux";
import { Tooltip, Progress, FloatButton } from "antd";
import { Link } from "react-router-dom";
import {
  useHistory,
  useLocation,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import DeleteIcon from "../../assets/icons/DeleteIcon.svg";
import DownArrowOption from "../../assets/icons/DownArrowOption.svg";
import Xicon from "../../assets/icons/Xicon.svg";
import XCircle from "../../assets/icons/x-circle.svg";
import Package from "../../assets/icons/package.svg";
import Setting from "../../assets/icons/tool.svg";
import addPart from "../../assets/icons/addPart.png";
import DelIcon from "../../assets/icons/DeleteIconCircle.svg";
import searchIcon from "../../assets/icons/search.svg";
import plusDottedIcon from "../../assets/icons/plus-dotted-icon.svg";
import AddButton from "../../assets/icons/Card Add button.svg";
import MakePurchaseTooltip from "../Common/MakePurchaseTooltip";
import Header from "../../layouts/Header";
import {
  AddProductPart,
  EmptyProductPart,
  FetchDocumentByProductPartId,
  FetchPartsList,
  FetchProductPart,
  FetchProductionHistory,
  FetchSuppliers,
  ProductPartCodeEmailExistOrNot,
  UpdateProduct,
  fetchTranslationData,
  ProductAndPartValidation,
  SupplierCodeExistOrNot,
  FetchProductPartCategories,
  FetchUnits,
  FetchBrandHealthApplication,
  FetchProductPartCode,
  SupplierBarCode,
  ProductpartBarCode,
  AddPartEquipments,
  FetchPartEquipments,
  UpdatePartEquipments,
  DeletePartEquipments,
} from "../../redux/actions/action";
import useScreenSize from "../../utils/hooks/useScreenSizeHook";
import "../../assets/styles/local/AddProduct.css";
import ColorPickers from "./ColorPickers";
import ProductImagesBB from "./ProductImagesBB";
import StockColorPickers from "./StockColorPickers";
import StockDocumentsTab from "./StockDocumentsTab";
import ProductComposition from "./ProductComposition";
import ComposedProductStock from "./ComposedProductStock";
import PartStock from "./PartStock";
import { FETCH_PRODUCTION_HISTORY } from "../../redux/constants/type";
import CancelWarningModal from "../Dailogs/CancelWarningModal";
import RouteLeavingGuard from "../Common/RouteLeavingGuard";
import TaskEquipmentList from "../../components/Dailogs/ProductEquipmentList";
import EuroFormat from "../../utils/EuroFormat/EuroFormat";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import {
  europeanFormatWithSymbol,
  europeanFormat,
} from "../../utils/European-Format/NumberFormatter";

const toCheckFieldList = [
  "supplierid",
  "itemid",
  // "productcolor",
  "costprice",
  // "min",
  // "max",
  // "instock",
  "leadtime",
];

const newSupplier = {
  supplierid: "",
  suppliername: "",
  searchSupplierName: "",
  itemid: "",
  // productcolor: "",
  costprice: 0,
  // min: "",
  // max: "",
  // instock: 0,

  // leadtime: 0,
  leadtime: "",
  showSupplierXIcon: false,
  showSupplierOptions: false,
};

const brand = ["IKEA", "IBM", "Nike", "Coca Cola", "Levis"];
const health = ["Ecological", "Health 1", "Health 2", "Health 3"];
const application = ["Wall Paint", "Stand", "Wall Paint 1", "Stand 1"];

const Tab = ({ label, isActive, onClick, showAlert = false }) => (
  <div
    className={
      isActive
        ? "col-1 products-and-parts-tab-pro"
        : "col-1 products-and-parts-tab"
    }
    style={{
      whiteSpace: "nowrap",
      width: "max-content",
      flexShrink: 0,
      display: "inline-block",
    }}
    onClick={onClick}
  >
    <label
      className={
        isActive
          ? "products-and-parts-tab-labels-pro"
          : "products-and-parts-tab-labels"
      }
    >
      {label}&nbsp;
      {showAlert && <MakePurchaseTooltip classes="align-top" />}
    </label>
    <hr
      className={
        isActive
          ? "products-and-parts-horizontal-bar-pro"
          : "products-and-parts-horizontal-bar"
      }
      style={{ width: "100%", margin: "auto" }}
    />
  </div>
);

const AddProduct = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const inputRef = useRef(null);
  const location = useLocation();
  const urlProductType = location.pathname.split("/")[1].split("-")[1];
  const urlProductTypeValue =
    urlProductType === "product"
      ? 0
      : urlProductType === "part"
        ? 1
        : urlProductType === "service"
          ? 2
          : null;
  const { urlProductPartId } = useParams();
  const productType = location.state?.productType ?? urlProductTypeValue;
  const productPartId = location?.state?.productPartId || urlProductPartId;
  const articleNumber = location?.state?.articleNumber;
  const materialName = location?.state?.materialName;
  const productPartCode = location?.state?.productpartcode;

  const [anchorEl, setAnchorEl] = useState(null);

  const [brand2, setBrand2] = useState([]);
  const [health2, setHealth2] = useState([]);
  const [application2, setApplication2] = useState([]);

  const [totalQty, setTotalQty] = useState(0);
  const [compositionData, setCompositionData] = useState([]);
  const [productionHistory, setProductionHistory] = useState([]);
  const [clientSearch, setClientSearch] = useState("");
  const [listData, setListData] = useState([]);
  const [stockData, setStockData] = useState({
    enableStockManagement: true,
    minimum: "",
    maximum: "",
    isPickingPart: true,
    isProductStockEntry: false,
    isFifo: true,
    isLifo: false,
    isAverage: false,
    unitCost: 0,
    qty: 0,
    totalCost: 0,
  });
  const tabStorageKey = `addProduct:activeTab:${location.pathname}:${productPartId || "new"}`;
  const [activeTab, setActiveTab] = useState(() => {
    try {
      const savedTab = sessionStorage.getItem(tabStorageKey);
      const validTabs = [
        "general",
        "images",
        "composition",
        "suppliers",
        "ProductionSteps",
        "documents",
        "partStock",
        "composedProductStock",
      ];
      return validTabs.includes(savedTab) ? savedTab : "general";
    } catch {
      return "general";
    }
  });
  const [showBrandOptions, setShowBrandOptions] = useState(false);
  const [showBrandXIcon, setShowBrandXIcon] = useState(false);
  const [showHealthOptions, setShowHealthOptions] = useState(false);
  const [showHealthXIcon, setShowHealthXIcon] = useState(false);
  const [showApplicationOptions, setShowApplicationOptions] = useState(false);
  const [showApplicationXIcon, setShowApplicationXIcon] = useState(false);
  const [modal, showModal] = useState(false);
  const [pillList, setPillList] = useState([]);
  // console.log("asc2",pillList)
  const [productCategoryList, setProductCategoryList] = useState("");
  const [supplier, setSupplier] = useState([]);
  const [isValueExists, setIsValueExists] = useState(false);
  const [itemNameError, setItemNameError] = useState(false);
  const [error, setError] = useState(false);
  const [minMaxError, setMinMaxError] = useState(false);
  const [isPartNameExist, setIsPartNameExist] = useState(false);
  const [isSupplierCodeExist, setIsSupplierCodeExist] = useState({
    status: false,
    suppCodeIndex: null,
  });
  const [productListOld, setProductListOld] = useState({});
  const [stockDataOld, setStockDataOld] = useState({});
  const [showLowStockAlert, setShowLowStockAlert] = useState(false);
  const [barCode, setBarCode] = useState("");

  const [productList, setProductList] = useState({
    productpartcode: articleNumber || "",
    productpartname: materialName || "",
    salepriceexcvat: 0,
    vatpercent: "21",
    coverimage: null,
    images: [],
    itemdescription: "",
    productpartvariation: [],
    productWeight: "",
    width: "",
    heigth: "",
    depth: "",
    brand: "",
    health: "",
    application: "",
    categories: "",
    aisle: "",
    row: "",
    bin: "",
    partoftheproduct: productType === 0 ? 0 : productType === 1 ? 1 : 2,
    stockmanagement: true,
    productpartsuppliers: [
      {
        supplierid: "",
        suppliername: "",
        searchSupplierName: "",
        itemid: "",
        // productcolor: "",
        costprice: 0,
        // min: "",
        // max: "",
        // instock: 0,

        // leadtime: 0,
        leadtime: "",
        showSupplierXIcon: false,
        showSupplierOptions: false,
      },
    ],
  });
  const [isBuildingBlock, setIsBuildingBlock] = useState(false);
  const [isPlusPackage, setIsPlusPackage] = useState(false);

  const getAppSideNavOptions = useSelector(
    (state) => state.user.appSideNavOptions,
  );

  const fetchProductPartCategoriesRes = useSelector(
    (state) => state.user.fetchProductPartCategoriesRes,
  );

  const fetchAutoProductPartItemIDRes = useSelector(
    (state) => state.user.fetchAutoProductPartItemIDRes,
  );

  const deletePartsEquipmentsRes = useSelector(
    (state) => state.user.deletePartsEquipmentsRes,
  );

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";

  const [categoriesData, setCategoriesData] = useState([]);
  const [categoriesBoxOpen, setCategoriesBoxOpen] = useState(false);

  const [itemID, setItemID] = useState("");

  useEffect(() => {
    dispatch(FetchProductPartCode({}));
  }, []);

  useEffect(() => {
    if (!productPartId && fetchAutoProductPartItemIDRes.status === true) {
      // setProductList({
      //   ...productList,
      //   productpartcode: fetchAutoProductPartItemIDRes?.data,
      // });

      // setProductList({
      //   ...productList,
      //   itemId: fetchAutoProductPartItemIDRes?.data,
      // });

      setItemID(fetchAutoProductPartItemIDRes?.data);
    }
  }, [fetchAutoProductPartItemIDRes]);

  useEffect(() => {
    dispatch(FetchProductPartCategories(productCategoryList));
  }, [productCategoryList]);

  useEffect(() => {
    if (fetchProductPartCategoriesRes.status === true) {
      setCategoriesData(fetchProductPartCategoriesRes.data);
    }
  }, [fetchProductPartCategoriesRes]);

  useEffect(() => {
    if (getAppSideNavOptions && getAppSideNavOptions.length > 0) {
      setIsBuildingBlock(
        getAppSideNavOptions.some(
          (x) => x.packageId === process.env.REACT_APP_IS_PREMIUM,
        ),
      );
    }
  }, [getAppSideNavOptions]);

  useEffect(() => {
    if (getAppSideNavOptions && getAppSideNavOptions.length > 0) {
      setIsPlusPackage(
        getAppSideNavOptions.some(
          (x) => x.packageId === process.env.REACT_APP_IS_PLUS,
        ),
      );
    }
  }, [getAppSideNavOptions]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    try {
      sessionStorage.setItem(tabStorageKey, tab);
    } catch {
      // Tab switching should still work when browser storage is unavailable.
    }
  };

  useEffect(() => {
    if (localStorage.getItem("Active_supplier_Tab")) {
      handleTabClick("suppliers");
      setTimeout(() => {
        localStorage.removeItem("Active_supplier_Tab");
      }, 1000);
    }
  }, []);

  //composition tab start
  const fetchPartsListRes = useSelector((state) => state.user.fetchPartsList);
  useEffect(() => {
    if (fetchPartsListRes?.status === true) {
      setCompositionData(fetchPartsListRes?.data);
    }
  }, [fetchPartsListRes]);
  useEffect(() => {
    // If clientSearch is empty, show all data
    if (!clientSearch) {
      setCompositionData(fetchPartsListRes?.data);
    } else {
      // Filter compositionData based on clientSearch
      const filteredData = compositionData?.filter(
        (item) =>
          item.partCode.toLowerCase().includes(clientSearch.toLowerCase()) ||
          item.partName.toLowerCase().includes(clientSearch.toLowerCase()),
      );
      setCompositionData(filteredData);
    }
  }, [clientSearch.length]);
  //composition tab end

  const fetchProductPartData = useSelector(
    (state) => state.user.fetchProductPart,
  );

  const productPartCodeEmailExistOrNotData = useSelector(
    (state) => state.user.productPartCodeEmailExistOrNot,
  );
  const productAndPartValidationRes = useSelector(
    (state) => state.user.productAndPartValidationRes,
  );
  const supplierCodeExistOrNotRes = useSelector(
    (state) => state.user.supplierCodeExistOrNotRes,
  );

  const handleCancel = () => {
    showModal(false);
    history.push("/productsList");
    setTimeout(() => {
      dispatch(EmptyProductPart());
      dispatch({
        type: FETCH_PRODUCTION_HISTORY,
        data: {},
      });
    }, 1000);
  };
  useEffect(() => {
    const payload = { productPartCode: productList?.productpartcode };
    dispatch(ProductPartCodeEmailExistOrNot(payload));
  }, [dispatch, productList?.productpartcode]);

  useEffect(() => {
    dispatch(ProductAndPartValidation(productList?.productpartname));
  }, [dispatch, productList?.productpartname]);

  const handleSupplierIdChange = (index, value) => {
    const item = productList.productpartsuppliers[index];
    dispatch(
      SupplierCodeExistOrNot({
        itemid: item.itemid,
      }),
    ).then((res) => {
      if (res?.status === true) {
        setIsSupplierCodeExist({
          status: true,
          suppCodeIndex: index,
        });
      } else {
        setIsSupplierCodeExist({
          status: false,
          suppCodeIndex: null,
        });
      }
    });
  };

  //productPartCode already exist
  useEffect(() => {
    if (productPartCodeEmailExistOrNotData.status === true) {
      if (
        productPartId &&
        productPartCode ===
          productPartCodeEmailExistOrNotData.data[0].productpartcode
      ) {
        setIsValueExists(false);
      } else {
        setIsValueExists(true);
      }
    } else {
      setIsValueExists(false);
    }
  }, [
    productList.productpartcode,
    productPartCode,
    productPartCodeEmailExistOrNotData.data,
    productPartCodeEmailExistOrNotData.status,
    productPartId,
  ]);

  useEffect(() => {
    if (
      fetchProductPartData?.status === true &&
      productAndPartValidationRes?.status === true
    ) {
      if (
        fetchProductPartData?.data[0]?.productpartname ===
        productAndPartValidationRes?.data[0]?.productPartName
      )
        return setIsPartNameExist(false);
    }
    if (productAndPartValidationRes.status === true)
      return setIsPartNameExist(true);
    if (productAndPartValidationRes.status === false)
      return setIsPartNameExist(false);
  }, [productAndPartValidationRes, fetchProductPartData]);

  useEffect(() => {
    if (productPartId) {
      const payload = {
        productpartid: productPartId,
      };
      dispatch(FetchProductPart(payload));
      dispatch(FetchDocumentByProductPartId(payload));

      const stockPayload = {
        productPartId: productPartId,
        // pagerequire: perPage,
        // pagenumber: currentPage + 1,
      };
      dispatch(FetchProductionHistory(stockPayload));
    }
  }, [dispatch, productPartId]);

  const fetchProductionHistoryData = useSelector(
    (state) => state.user.fetchProductionHistory,
  );
  useEffect(() => {
    if (fetchProductionHistoryData != null) {
      if (
        fetchProductionHistoryData?.status &&
        fetchProductionHistoryData?.data
      ) {
        setProductionHistory(fetchProductionHistoryData?.data?.data);
      }
    }
  }, [fetchProductionHistoryData?.data]);

  useEffect(() => {
    if (fetchProductPartData.status === true) {
      const updatedFetchProductPartData = { ...fetchProductPartData?.data[0] };
      // Normalize nullable text fields from API so UI `.length` checks are safe.
      updatedFetchProductPartData.productpartcode =
        updatedFetchProductPartData.productpartcode ?? "";
      updatedFetchProductPartData.productpartname =
        updatedFetchProductPartData.productpartname ?? "";
      updatedFetchProductPartData.brand =
        updatedFetchProductPartData.brand ?? "";
      updatedFetchProductPartData.health =
        updatedFetchProductPartData.health ?? "";
      updatedFetchProductPartData.application =
        updatedFetchProductPartData.application ?? "";
      updatedFetchProductPartData.productWeight =
        updatedFetchProductPartData.weight ?? "";
      updatedFetchProductPartData.productpartsuppliers = [
        ...updatedFetchProductPartData.productpartsuppliers.map(
          (partSupplier) => ({
            ...partSupplier,
            suppliername: supplier.find(
              (x) => x.supplierid === partSupplier.supplierid,
            )?.suppliername,
          }),
        ),
        { ...newSupplier },
      ];
      updatedFetchProductPartData.coverimage =
        fetchProductPartData?.data[0]?.cover;
      updatedFetchProductPartData.images = fetchProductPartData?.data[0]?.image;
      const _productParts =
        updatedFetchProductPartData.productpartsuppliers.filter(
          (o) => o.lowStock,
        );
      setShowLowStockAlert(_productParts.length > 0);

      setItemID(fetchProductPartData?.data[0]?.itemid);
      setBarCode(fetchProductPartData?.data[0]?.barCode);

      setProductList(updatedFetchProductPartData);
      setProductListOld(updatedFetchProductPartData);
    }
  }, [fetchProductPartData, supplier]);

  useEffect(() => {
    if (fetchProductPartData && fetchProductPartData.status === true) {
      const categoriesArray =
        fetchProductPartData.data[0]?.categories?.split(",");
      const uniqueCategories = new Set(categoriesArray);
      // setPillList(Array.from(uniqueCategories));
      let data = [];
      fetchProductPartData.data[0].productpartcategories
        ?.filter((x) => x.categories !== "")
        .map((item) => {
          return data.push({
            ascCategoriesName: item.categories,
          });
        });
      setPillList(data);

      const tmp = fetchProductPartData.data[0].stock
        ? fetchProductPartData.data[0].stock
        : stockData;
      setStockData(tmp);
      setStockDataOld(tmp);
      setListData(fetchProductPartData.data[0].partsList);
      setUnitName(fetchProductPartData?.data[0]?.unit);
      console.log("asc23", fetchProductPartData?.data[0]?.unit);
    }
  }, [fetchProductPartData]);

  const handleChange = (e) => {
    setIsClicked(false);
    const { name, value } = e.target;
    setProductList((prevState) => ({
      ...prevState,
      // [name]: value,
      [name]: name === "productWeight" ? value.replace(",", ".") : value,
    }));
    setTypeInScreen(e.target.value);

    console.log(productList, name, value);
  };
  const screenSize = useScreenSize();
  // const handleChangeCheckbox = (e) => {
  //   const { name, value, type, checked } = e.target;
  //   setProductList((prevState) => ({
  //     ...prevState,
  //     [name]: type === "checkbox" ? checked : value,
  //   }));
  // };

  useEffect(() => {
    if (listData) {
      const tmp = listData.reduce((totalCost, item) => {
        // const unitCost = item.unitCost !== "" ? +item.unitCost : 0;
        const unitCost =
          typeof item.unitCost === "string"
            ? Number(item.unitCost.replace(",", "."))
            : Number(item.unitCost) || 0;
        const itemCost =
          isNaN(unitCost) || isNaN(+item.quantity)
            ? 0
            : unitCost * +item.quantity;
        return totalCost + itemCost;
      }, 0);
      setTotalQty(tmp);
    } else {
      setTotalQty(0);
    }
  }, [listData]);

  const fetchSuppliersProductList = useSelector(
    (state) => state.user.fetchSuppliersProduct,
  );

  const fetchBrandHealthApplicationRes = useSelector(
    (state) => state.user.fetchBrandHealthApplicationRes,
  );

  useEffect(() => {
    if (+stockData.maximum === "" && +stockData.minimum === "") {
      setMinMaxError(false);
    } else
      setMinMaxError(+stockData.minimum > +stockData.maximum ? true : false);
  }, [stockData.maximum, stockData.minimum]);

  useEffect(() => {
    if (!productList?.productpartname.length > 0 && productPartId) {
      setItemNameError(!itemNameError);
    } else {
      setItemNameError(false);
    }
  }, [productList?.productpartname, productPartId]);

  useEffect(() => {
    if (!productList?.productpartcode.length > 0 && error) {
      setError(!error);
    } else {
      setError(false);
    }
  }, [productList?.productpartcode]);

  useEffect(() => {
    if (fetchSuppliersProductList.status === true) {
      setSupplier(fetchSuppliersProductList?.data);
      // setBrand2(fetchSuppliersProductList?.data);
    }
    setProductListOld(productList);
  }, [fetchSuppliersProductList]);

  useEffect(() => {
    if (fetchBrandHealthApplicationRes.status === true) {
      // setBrand2(fetchBrandHealthApplicationRes?.data);
    }
  }, [fetchBrandHealthApplicationRes]);

  useEffect(() => {
    dispatch(FetchSuppliers());
    dispatch(FetchPartsList());
    dispatch(FetchBrandHealthApplication({ type: "Brand" })).then((res) => {
      setBrand2(res?.data);
    });
    dispatch(FetchBrandHealthApplication({ type: "Health" })).then((res) => {
      setHealth2(res?.data);
    });
    dispatch(FetchBrandHealthApplication({ type: "Application" })).then(
      (res) => {
        setApplication2(res?.data);
      },
    );
  }, [dispatch]);

  // const handleCategoryEnter = (event) => {
  //   if (event.key === "Enter" && productCategoryList.trim() !== "") {
  //     const word = productCategoryList.trim();

  //     setPillList([...pillList, word]);
  //     inputRef.current.focus();

  //     setProductList((prevState) => ({
  //       ...prevState,
  //       categories: [...pillList, word],
  //     }));

  //     setProductCategoryList("");
  //   } else {
  //     const word = productCategoryList.trim();
  //     setProductList((prevState) => ({
  //       ...prevState,
  //       categories: [...pillList, word],
  //     }));
  //   }
  // };

  // const removeCategoriesItems = (index) => {
  //   const updatedList = [...pillList];
  //   updatedList.splice(index, 1);
  //   setPillList(updatedList);

  //   const updateCategory = [...productList.categories];
  //   updateCategory.splice(index, 1);
  //   setProductList((prevState) => ({
  //     ...prevState,
  //     categories: updateCategory,
  //   }));
  //   inputRef.current.focus();
  // };

  const handleCategoryEnter_ASC = (e) => {
    if (e.key === "Enter") {
      let data = [...pillList];
      data.push({
        ascCategoriesName: e.target.value,
      });
      setPillList(data);
      setProductCategoryList("");
    }
  };

  function isValidISODate(dateString) {
    // Regular expression pattern for ISO date format
    var isoDatePattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{1,9})?Z?$/;
    return isoDatePattern.test(dateString);
  }
  const addProduct = async () => {
    if (productionRowSaveRef.current) return;
    setTypeInScreen("");
    setIsClicked(true);
    if (
      productPartId &&
      productList.productpartname
      // &&      +stockData.minimum < +stockData.maximum
    ) {
      const { productpartcode, cover, image, images, ...restOfProductList } =
        productList;
      const payloadPartsList = listData?.map((item) => ({
        partId: item.partID,
        quantity: item.quantity || 0, // Use 0 if quantity is undefined or falsy
        unitCost: item.unitCost || 0, // Use 0 if unitCost is undefined or falsy
        totalCost: item.totalCost || 0, // Use 0 if totalCost is undefined or falsy
      }));
      const stockPayload = stockData.enableStockManagement
        ? {
            enableStockManagement: stockData.enableStockManagement,
            minimum: stockData.minimum ? stockData.minimum : 0,
            maximum: stockData.maximum ? stockData.maximum : 0,
            isPickingPart: stockData.isPickingPart,
            isProductStockEntry: stockData.isProductStockEntry,
            isFifo: stockData.isFifo,
            isLifo: stockData.isLifo,
            isAverage: stockData.isAverage,
            unitCost:
              activeTab === "composedProductStock"
                ? totalQty
                : productList?.productpartsuppliers[0]?.costprice === ""
                  ? 0
                  : String(
                      productList?.productpartsuppliers[0]?.costprice,
                    ).replace(/[, €]/g, ""),
            qty: stockData.qty,
            totalCost:
              activeTab === "composedProductStock"
                ? totalQty
                : productList?.productpartsuppliers[0]?.costprice *
                    stockData.qty || 0, // Handle null values by providing a default value
          }
        : {
            enableStockManagement: false,
            minimum: 0,
            maximum: 0,
            isPickingPart: true,
            isProductStockEntry: false,
            isFifo: true,
            isLifo: false,
            isAverage: false,
            unitCost:
              activeTab === "composedProductStock"
                ? totalQty
                : productList?.productpartsuppliers[0]?.costprice === ""
                  ? 0
                  : String(
                      productList?.productpartsuppliers[0]?.costprice,
                    ).replace(/[, €]/g, ""),
            qty: 0,
            totalCost: 0,
          };
      const updatedProductPartSuppliers = productList.productpartsuppliers
        .map((supplier) => {
          const updatedCostPrice = supplier?.costprice
            ? String(supplier?.costprice)?.replace(/[ €]/g, "")
            : 0;
          const updatedSupplier = toCheckFieldList.reduce((acc, key) => {
            if (supplier.hasOwnProperty(key)) {
              acc[key] = key === "costprice" ? updatedCostPrice : supplier[key];
            }
            return acc;
          }, {});

          const productPartSupplierId =
            supplier.productpartsupplierid ??
            supplier.productPartSupplierid ??
            supplier.productPartSupplierId;

          if (productPartSupplierId) {
            updatedSupplier.productpartsupplierid = productPartSupplierId;
          }

          return updatedSupplier;
        })
        .filter((supplier) => {
          return Object.values(supplier).some(
            (value) =>
              value !== "" &&
              value !== null &&
              value !== undefined &&
              value !== 0,
          );
        });

      // ensure we get latest barcode URL from server
      let barcodeUrl = barCode;
      try {
        const res = await dispatch(
          ProductpartBarCode({
            itemid: productList.productpartcode,
          }),
        );
        if (res && res.status === true) barcodeUrl = res.data.url;
      } catch (e) {}

      const payload = {
        ...restOfProductList,
        // salepriceexcvat:
        //   productList.salepriceexcvat.toString().replace(".", ",") ?? 0,
        salepriceexcvat:
          productType === 0
            ? String(totalQty + totalProductionCost).replace(".", ",")
            : (productList.salepriceexcvat?.toString().replace(".", ",") ?? 0),
        coverimage: productList.coverimage ? productList.coverimage : "",
        // categories: productList.categories.toString(),
        // categories: "",
        productpartcategories: pillList?.map((x) => {
          return { categories: x?.ascCategoriesName?.trim() };
        }),

        partoftheproduct: productType === 0 ? 0 : productType === 1 ? 1 : 2,
        stockmanagement: productList.stockmanagement ? 1 : 0,
        productpartid: productPartId,
        productpartvariation: productList.productpartvariation.map(
          (variation) => {
            if (isValidISODate(variation.productpartvariationid)) {
              return { colorcode: variation.colorcode };
            }

            return variation;
          },
        ),
        productpartsuppliers: updatedProductPartSuppliers,
        productpartimages: productList.images.map((val) => ({
          productpartimageid: val.productpartimageid,
          image: val.image,
        })),
        aisle: productList.aisle,
        row: productList.row,
        bin: productList.bin,
        unit: unitName,
        partsList: payloadPartsList,
        // stock: stockPayload,
        stock: productType !== 2 ? stockPayload : null,
        productpartcode: productpartcode,
        weight: productList.productWeight,
        barcode: barcodeUrl,
      };
      delete payload.barCode;
      dispatch(UpdateProduct(payload));
    } else {
      if (
        productList.productpartcode.length > 0 &&
        productList?.productpartname.length > 0
        // &&        +stockData.minimum <= +stockData.maximum
      ) {
        const { images, ...restOfProductList } = productList;
        const payloadPartsList = listData?.map((item) => ({
          partId: item.partID,
          quantity: item.quantity || 0, // Use 0 if quantity is undefined or falsy
          unitCost: item.unitCost || 0, // Use 0 if unitCost is undefined or falsy
          totalCost: item.totalCost || 0, // Use 0 if totalCost is undefined or falsy
        }));
        const stockPayload = stockData.enableStockManagement
          ? {
              enableStockManagement: stockData.enableStockManagement,
              minimum: stockData.minimum ? stockData.minimum : 0,
              maximum: stockData.maximum ? stockData.maximum : 0,
              isPickingPart: stockData.isPickingPart,
              isProductStockEntry: stockData.isProductStockEntry,
              isFifo: stockData.isFifo,
              isLifo: stockData.isLifo,
              isAverage: stockData.isAverage,
              unitCost:
                activeTab === "composedProductStock"
                  ? totalQty
                  : productList?.productpartsuppliers[0]?.costprice === ""
                    ? 0
                    : String(
                        productList?.productpartsuppliers[0]?.costprice,
                      ).replace(/[, €]/g, ""),
              qty: stockData.qty,
              totalCost:
                activeTab === "composedProductStock"
                  ? totalQty
                  : String(
                      productList?.productpartsuppliers[0]?.costprice,
                    ).replace(/[, €]/g, "") * stockData.qty,
            }
          : {
              enableStockManagement: false,
              minimum: 0,
              maximum: 0,
              isPickingPart: true,
              isProductStockEntry: false,
              isFifo: true,
              isLifo: false,
              isAverage: false,
              unitCost: 0,
              qty:
                activeTab === "composedProductStock"
                  ? totalQty
                  : productList?.productpartsuppliers[0]?.costprice === ""
                    ? 0
                    : String(
                        productList?.productpartsuppliers[0]?.costprice,
                      ).replace(/[, €]/g, ""),
              totalCost: 0,
            };
        const updatedProductPartSuppliers = productList.productpartsuppliers
          .map((supplier) => {
            const updatedCostPrice = supplier.costprice
              ? String(supplier?.costprice).replace(/[ €]/g, "")
              : 0;
            const updatedSupplier = toCheckFieldList.reduce((acc, key) => {
              if (supplier.hasOwnProperty(key)) {
                acc[key] =
                  key === "costprice" ? updatedCostPrice : supplier[key];
              }
              return acc;
            }, {});

            const productPartSupplierId =
              supplier.productpartsupplierid ??
              supplier.productPartSupplierid ??
              supplier.productPartSupplierId;

            if (productPartSupplierId) {
              updatedSupplier.productpartsupplierid = productPartSupplierId;
            }

            return updatedSupplier;
          })
          .filter((supplier) => {
            return Object.values(supplier).some(
              (value) =>
                value !== "" &&
                value !== null &&
                value !== undefined &&
                value !== 0,
            );
          });

        // dispatch(
        //   SupplierBarCode({
        //     itemids: updatedProductPartSuppliers?.map((x) => x.itemid),
        //   }),
        // ).then((barcodeRes) => {
        //   const finalSuppliers = updatedProductPartSuppliers.map((supplier) => {
        //     const barcodeObj = barcodeRes.data.find(
        //       (x) => x.itemid === supplier.itemid,
        //     );

        //     return {
        //       ...supplier,
        //       barcode: barcodeObj?.url || "",
        //     };
        //   });

        const payload = {
          ...restOfProductList,
          // salepriceexcvat: productList.salepriceexcvat ?? 0,
          salepriceexcvat:
            productType === 0
              ? String(totalQty + totalProductionCost).replace(".", ",")
              : (productList.salepriceexcvat ?? 0),
          coverimage: productList.coverimage ? productList.coverimage : "",
          // categories: productList.categories.toString(),
          productpartcategories: pillList?.map((x) => {
            return { categories: x?.ascCategoriesName?.trim() };
          }),
          partoftheproduct: productType === 0 ? 0 : productType === 1 ? 1 : 2,
          stockmanagement: productList.stockmanagement ? 1 : 0,
          productpartsuppliers: updatedProductPartSuppliers,
          // productpartsuppliers: finalSuppliers,
          productpartvariation: productList.productpartvariation.map(
            ({ colorcode }) => ({ colorcode }),
          ),
          weight: productList.productWeight,
          productartsimages: productList.images,
          aisle: productList.aisle,
          row: productList.row,
          bin: productList.bin,
          unit: unitName,
          partsList: payloadPartsList,
          // stock: stockPayload,
          stock: productType !== 2 ? stockPayload : null,
          itemId: itemID,
          barcode: barCode,
        };
        dispatch(AddProductPart(payload));
        // }); .then ka block
      } else {
        if (
          !productList?.productpartname.length > 0 &&
          !productList.productpartcode.length > 0
        ) {
          setError(true);
          setItemNameError(true);
        } else if (!productList.productpartcode.length > 0) {
          setError(true);
        } else if (!productList?.productpartname.length > 0) {
          setItemNameError(true);
        } else if (+stockData.minimum >= +stockData.maximum) {
          setMinMaxError(true);
        }
      }
    }
  };

  // Auto-select newly added supplier start
  const newSupplierData = JSON.parse(localStorage.getItem("newSupplierData"));
  const newSupplierIndex = Number(localStorage.getItem("newSupplierIndex"));

  useEffect(() => {
    if (newSupplierData && newSupplierIndex !== null) {
      setProductList((prev) => {
        let list = prev.productpartsuppliers || [];

        if (list.length === 0) {
          list = [{}];
        }

        const updatedList = [...list];
        const lastIndex = updatedList.length - 1;

        // ensure index exists
        if (!updatedList[lastIndex]) {
          updatedList[lastIndex] = {};
        }

        updatedList[lastIndex] = {
          ...updatedList[lastIndex],
          supplierid: newSupplierData?.supplierid,
          suppliername: newSupplierData?.suppliername,
        };

        return {
          ...prev,
          productpartsuppliers: updatedList,
        };
      });

      setTimeout(() => {
        localStorage.removeItem("newSupplierData");
        localStorage.removeItem("newSupplierIndex");
      }, 3000);
    }
  }, [newSupplierData]);
  // Auto-select newly added supplier end

  const handleStockData = (supplierIndex, event, action) => {
    const updatedProductList = { ...productList };
    if (event && event.target) {
      const { name, value } = event.target;
      updatedProductList.productpartsuppliers[supplierIndex][
        name.split("-")[0]
      ] = value;
      setProductList(updatedProductList);
    }

    if (action === "showOptions") {
      if (event?.target) {
        updatedProductList.productpartsuppliers[supplierIndex].suppliername =
          event?.target ? event.target.value : "";
        updatedProductList.productpartsuppliers[
          supplierIndex
        ].searchSupplierName = event?.target ? event.target.value : "";
      } else {
        updatedProductList.productpartsuppliers[
          supplierIndex
        ].showSupplierOptions = true;
        setProductList(updatedProductList);
      }
    } else if (action === "hideOptions") {
      updatedProductList.productpartsuppliers[
        supplierIndex
      ].showSupplierOptions = false;
      updatedProductList.productpartsuppliers[
        supplierIndex
      ].searchSupplierName = "";
      setProductList({ ...updatedProductList });
    } else if (action === "hideXIcon") {
      updatedProductList.productpartsuppliers[supplierIndex].showSupplierXIcon =
        false;
      updatedProductList.productpartsuppliers[supplierIndex].supplierid = "";
      updatedProductList.productpartsuppliers[supplierIndex].suppliername = "";
      setProductList(updatedProductList);
    } else if (action === "selectSupplier") {
      updatedProductList.productpartsuppliers[supplierIndex].supplierid =
        event.supplierid;
      updatedProductList.productpartsuppliers[supplierIndex].suppliername =
        event.suppliername;
      updatedProductList.productpartsuppliers[
        supplierIndex
      ].showSupplierOptions = false;
      updatedProductList.productpartsuppliers[supplierIndex].showSupplierXIcon =
        true;
      updatedProductList.productpartsuppliers[
        supplierIndex
      ].searchSupplierName = "";

      setProductList(updatedProductList);
    }
    productPartSuppliers();
  };

  const productPartSuppliers = () => {
    const existingSupplier =
      productList?.productpartsuppliers[
        (productList?.productpartsuppliers?.length || 1) - 1
      ];

    const isAddNewSupplier = toCheckFieldList
      .filter((key) => key !== "itemid") // skip supplierCode, add new row
      .every((key) => existingSupplier[key].toString());
    if (isAddNewSupplier) {
      setProductList((prevState) => ({
        ...prevState,
        productpartsuppliers: [
          ...prevState.productpartsuppliers,
          { ...newSupplier },
        ],
      }));
    }
  };

  const handleDeleteSupplier = (index) => {
    // Check if there is only one supplier in the array
    if (productList.productpartsuppliers.length === 1) {
      return;
    }

    const updatedSuppliers = [...productList.productpartsuppliers];
    updatedSuppliers.splice(index, 1);

    setProductList({
      ...productList,
      productpartsuppliers: updatedSuppliers,
    });
  };

  useEffect(() => {
    const tmpHealthData = health.some((item) =>
      item?.toLowerCase().includes(productList.health?.toLocaleLowerCase?.()),
    );
    if (productList.health?.length > 0) {
      if (!tmpHealthData && showHealthXIcon) {
        setShowHealthOptions(false);
      }
    }
  }, [productList.health]);

  useEffect(() => {
    const tmpApplicationData = application.some((item) =>
      item
        ?.toLowerCase()
        .includes(productList.application?.toLocaleLowerCase?.()),
    );
    if (productList.application?.length > 0) {
      if (!tmpApplicationData && showApplicationXIcon) {
        setShowApplicationOptions(false);
      }
    }
  }, [productList.application]);

  const isDataChanged =
    JSON.stringify(productListOld) !== JSON.stringify(productList) ||
    JSON.stringify(stockDataOld) !== JSON.stringify(stockData);

  const [typeInScreen, setTypeInScreen] = useState("");

  const cancelModal = () => {
    if (typeInScreen !== "") {
      showModal(true);
    } else {
      dispatch(EmptyProductPart());
      dispatch({
        type: FETCH_PRODUCTION_HISTORY,
        data: {},
      });
      // history.push("/productsList");
      history.goBack();
    }
  };

  const addProductPartData = useSelector((state) => state.user.addProductPart);

  const updateProductPartData = useSelector(
    (state) => state.user.updateProductPart,
  );

  useEffect(() => {
    if (
      addProductPartData.status === true ||
      updateProductPartData.status === true
    ) {
      const savedProductPartId =
        productPartId || addProductPartData?.data?.productPartid;
      addProductionEquipment(savedProductPartId);
      dispatch(EmptyProductPart());
      history.goBack();
    }
  }, [addProductPartData, updateProductPartData]);

  const refTypeDropDownContainer = useRef();
  const refTypeDropDownContainerExclude = useRef();
  const handleMouseDowTypeDD = (event) => {
    if (
      refTypeDropDownContainer?.current &&
      !refTypeDropDownContainer?.current?.contains(event.target) &&
      !refTypeDropDownContainerExclude?.current?.contains(event.target)
    ) {
      handleStockData(0, null, "hideOptions");
      handleStockData(0, null, "hideXIcon");
    }
  };
  useEffect(() => {
    window.addEventListener("mousedown", handleMouseDowTypeDD);

    return () => {
      window.removeEventListener("mousedown", handleMouseDowTypeDD);
    };
  }, []);

  useEffect(() => {
    fetchScreenTranslations("Add Products and Parts").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  const [isClicked, setIsClicked] = useState(false);

  // ASC CLOSE DROP DOWN CLICK OUT SIDE START ///
  const filter_Popup_Ref = useRef(null);
  const supplierDropdownContainerRef = useRef(null);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (
      filter_Popup_Ref.current &&
      !filter_Popup_Ref.current.contains(event.target)
    ) {
      setUnitOptions(false);
    }

    if (
      supplierDropdownContainerRef.current &&
      !supplierDropdownContainerRef.current.contains(event.target)
    ) {
      setProductList((prev) => {
        const hasOpenSupplier = prev?.productpartsuppliers?.some(
          (s) => s.showSupplierOptions,
        );

        if (!hasOpenSupplier) return prev;

        return {
          ...prev,
          productpartsuppliers: prev.productpartsuppliers.map((s) => ({
            ...s,
            showSupplierOptions: false,
            searchSupplierName: "",
          })),
        };
      });
    }
  };
  /// ASC CLOSE DROP DOWN CLICK OUT SIDE END ///

  // for services start
  const fecthUnitsProductsRes = useSelector(
    (state) => state.user.fecthUnitsProductsRes,
  );

  const [arrowOptionsRotate, setArrowOptionsRotate] = useState(false);

  const [unitOptions, setUnitOptions] = useState(false);
  const [unitData, setUnitData] = useState([]);
  const [unitName, setUnitName] = useState("");
  const [unitID, setUnitID] = useState("");

  const [supplierSearch, setSupplierSearch] = useState("");

  useEffect(() => {
    if (productType === 2) {
      dispatch(FetchUnits("Service"));
    } else {
      dispatch(FetchUnits());
    }
  }, []);

  useEffect(() => {
    if (fecthUnitsProductsRes?.status === true) {
      setUnitData(fecthUnitsProductsRes?.data);
    }
  }, [fecthUnitsProductsRes]);
  // for services end

  const isInvalid = productList?.productpartsuppliers?.some((item) => {
    if (item.suppliername?.trim()) {
      // return !item.itemid || !item.costprice || !item.leadtime;
      return !item.costprice || !item.leadtime; // skip supplier code
    }
    return false;
  });

  console.log("asc555", isInvalid);

  const fieldErrors = productList?.productpartsuppliers?.map((item) => {
    if (!item.suppliername?.trim()) return {};

    return {
      itemid: !item.itemid,
      costprice: !item.costprice,
      leadtime: !item.leadtime,
    };
  });

  // Production Steps Tab
  const emptyRow = () => ({
    rowId: crypto.randomUUID(),
    equipment: "",
    process: "",
    timeUnit: "",
    setupTime: "",
    runTime: "",
    timeUnitPrice: "",
    totalEquipCost: "",
    co2: "",
  });

  const [productionRows, setProductionRows] = useState([emptyRow()]);
  const [isAddingProductionRow, setIsAddingProductionRow] = useState(false);
  const productionRowSaveRef = useRef(false);
  const [productionRowError, setProductionRowError] = useState("");
  const [toggleEquipment, setToggleEquipment] = useState(false);
  const [selectedEquipmentsByRow, setSelectedEquipmentsByRow] = useState([]);

  // total setup and run time
  const totalProductionTime = productionRows.reduce((total, row) => {
    const setupTime = parseFloat(row.setupTime) || 0;
    const runTime = parseFloat(row.runTime) || 0;

    return total + setupTime + runTime;
  }, 0);

  // total of total cost
  const totalProductionCost = productionRows.reduce((total, row) => {
    const cost =
      parseFloat(String(row.totalEquipCost || "").replace(",", ".")) || 0;

    return total + cost;
  }, 0);

  // total of co2
  const totalProductionCO2 = productionRows.reduce((total, row) => {
    const co2 = parseFloat(String(row.co2 || "").replace(",", ".")) || 0;

    return total + co2;
  }, 0);

  const updateField2 = (rowIndex, field, value) => {
    setProductionRows((prev) =>
      prev.map((row, index) =>
        index === rowIndex ? { ...row, [field]: value } : row,
      ),
    );
  };

  const updateField = (rowIndex, field, value) => {
    setProductionRows((prev) =>
      prev.map((row, index) => {
        if (index !== rowIndex) return row;

        const updatedRow = {
          ...row,
          [field]: value,
        };

        if (updatedRow.timeUnit === "One-Off") {
          return {
            ...updatedRow,
            totalEquipCost: updatedRow.timeUnitPrice,
          };
        }

        const setupTime =
          parseFloat(String(updatedRow.setupTime || "").replace(",", ".")) || 0;

        const runTime =
          parseFloat(String(updatedRow.runTime || "").replace(",", ".")) || 0;

        const timeUnitPrice =
          parseFloat(
            String(updatedRow.timeUnitPrice || "").replace(",", "."),
          ) || 0;

        return {
          ...updatedRow,
          totalEquipCost: (setupTime + runTime) * timeUnitPrice,
        };
      }),
    );
  };

  const addProdRow = async () => {
    if (productionRowSaveRef.current) return;
    if (!productPartId) {
      setProductionRows((prev) => [...prev, emptyRow()]);
      return;
    }

    const row = productionRows[productionRows.length - 1];
    productionRowSaveRef.current = true;
    setIsAddingProductionRow(true);
    setProductionRowError("");
    try {
      // If refreshing failed after a successful save, retry only the refresh.
      if (!row.savedToApi) {
        const result = await dispatch(
          AddPartEquipments({
            partid: productPartId,
            partequipments: [
              {
                equipmentid: row.equipmentid,
                process: row.process,
                timeUnit: row.timeUnit,
                setupTime: String(row.setupTime || ""),
                runTime: String(row.runTime || ""),
                timeUnitPrice: (row.timeUnitPrice ?? 0)
                  .toString()
                  .replace(".", ","),
                totalCost: String(row.totalEquipCost ?? 0).replace(".", ","),
                cO2: String(row.co2 || ""),
              },
            ],
          }),
        );
        if (result?.status !== true) {
          throw new Error("Could not save production step. Please try again.");
        }
        setProductionRows((prev) =>
          prev.map((item) =>
            item.rowId === row.rowId ? { ...item, savedToApi: true } : item,
          ),
        );
      }

      const result = await dispatch(
        FetchPartEquipments({ partid: productPartId }),
      );
      if (result?.status !== true) {
        throw new Error(
          "Production step saved, but refresh failed. Click + to retry.",
        );
      }
      const savedRow = result.data?.find(
        (item) =>
          item.equipmentid === row.equipmentid &&
          !productionRows.some(
            (existing) => existing.partEquipmentid === item.partEquipmentid,
          ),
      );
      if (!savedRow?.partEquipmentid) {
        throw new Error(
          "Production step saved, but refresh failed. Click + to retry.",
        );
      }
      setProductionRows((prev) => [
        ...prev.map((item) =>
          item.rowId === row.rowId
            ? {
                ...item,
                partEquipmentid: savedRow.partEquipmentid,
                originalEquipmentid: row.equipmentid,
              }
            : item,
        ),
        emptyRow(),
      ]);
    } catch (error) {
      setProductionRowError(error.message);
    } finally {
      productionRowSaveRef.current = false;
      setIsAddingProductionRow(false);
    }
  };

  const removeRow = (rowIndex, deleteID) => {
    if (deleteID) {
      dispatch(DeletePartEquipments({ partEquipmentid: deleteID }));
    } else {
      setProductionRows((prev) =>
        prev.length > 1 ? prev.filter((_, index) => index !== rowIndex) : prev,
      );
      setSelectedEquipmentsByRow((prev) =>
        prev.filter((_, index) => index !== rowIndex),
      );
    }
  };

  const toggleEquipmentFun = () => {
    setToggleEquipment(false);
  };

  const addProductionEquipment = async (savedProductPartId) => {
    const changedEquipmentRows = productionRows.filter(
      (row) =>
        row.partEquipmentid && row.originalEquipmentid !== row.equipmentid,
    );

    const addPayload = {
      partid: productPartId || savedProductPartId,
      partequipments: productionRows.flatMap((row, index) => {
        const isNewRow = !row.partEquipmentid && !row.savedToApi;
        const isEquipmentChanged =
          row.partEquipmentid && row.originalEquipmentid !== row.equipmentid;

        if (!isNewRow && !isEquipmentChanged) return [];

        const selectedEquipment = selectedEquipmentsByRow[index]?.[0];
        if (!selectedEquipment) return [];

        return [
          {
            equipmentid: selectedEquipment.equipmentid,
            process: row.process,
            timeUnit: row.timeUnit,
            setupTime: String(row.setupTime || ""),
            runTime: String(row.runTime || ""),
            timeUnitPrice: (row.timeUnitPrice ?? 0)
              .toString()
              .replace(".", ","),
            totalCost: String(row.totalEquipCost ?? 0)
              .toString()
              .replace(".", ","),
            cO2: String(row.co2 || ""),
          },
        ];
      }),
    };

    const updatePayload = {
      partequipments: productionRows
        .filter(
          (row) =>
            row.partEquipmentid &&
            row.originalEquipmentid === row.equipmentid &&
            (row.process ||
              row.timeUnit ||
              row.setupTime ||
              row.runTime ||
              row.timeUnitPrice ||
              row.totalEquipCost ||
              row.co2),
        )
        .map((row) => ({
          partEquipmentid: row.partEquipmentid,
          process: row.process,
          timeUnit: row.timeUnit,
          setupTime: String(row.setupTime || ""),
          runTime: String(row.runTime || ""),
          timeUnitPrice: (row.timeUnitPrice ?? 0).toString().replace(".", ","),
          totalCost: String(row.totalEquipCost ?? 0)
            .toString()
            .replace(".", ","),
          cO2: String(row.co2 || ""),
        })),
    };

    try {
      for (const row of changedEquipmentRows) {
        await dispatch(
          DeletePartEquipments({
            partEquipmentid: row.partEquipmentid,
          }),
        );
      }

      if (addPayload.partequipments.length) {
        await dispatch(AddPartEquipments(addPayload));
      }

      if (updatePayload.partequipments.length) {
        await dispatch(UpdatePartEquipments(updatePayload));
      }
    } catch (error) {
      console.error("Save production equipment API failed:", error);
    }
  };

  useEffect(() => {
    if (!productPartId) return;

    dispatch(FetchPartEquipments({ partid: productPartId })).then((res) => {
      if (res?.status !== true) return;

      const equipments = res?.data || [];

      const rows = equipments.map((item) => ({
        partEquipmentid: item.partEquipmentid,
        equipmentid: item.equipmentid,
        originalEquipmentid: item.equipmentid,
        equipment: item.equipmentname || "",
        process: item.process || "",
        timeUnit: item.timeUnit || "",
        setupTime: item.setupTime || "",
        runTime: item.runTime || "",
        timeUnitPrice: item.timeUnitPrice || "",
        totalEquipCost: item.totalCost || "",
        co2: item.cO2 || "",
      }));

      const selections = equipments.map((item) => [
        {
          equipmentid: item.equipmentid,
          equipmentname: item.equipmentname || "",
        },
      ]);

      setProductionRows([...rows, emptyRow()]);
      setSelectedEquipmentsByRow([...selections, []]);
    });
  }, [dispatch, productPartId, deletePartsEquipmentsRes]);

  return (
    <>
      <Header
        leftComponent={
          <div className="products-and-parts-header-content">
            <div
              className="products-and-parts-main-title cursor-pointer"
              onClick={() => {
                history.push("/stock");
              }}
            >
              {/* Stock */}
              {t("Stock")}
            </div>
            <Link to="/productsList" className="nav-link">
              <div className="products-and-parts-sub-title products_and_parts_subtitle w-auto">
                {/* Products & Parts */}
                {/* {FetchTranslationList[10]?.translation} */}

                {/* {productPartId
                  ? productType === 0
                    ? FetchTranslationList[95]?.translation
                    : FetchTranslationList[102]?.translation
                  : productType === 0
                  ? FetchTranslationList[95]?.translation
                  : FetchTranslationList[90]?.translation} */}

                {productType === 2
                  ? // ? "Service"
                    t("Service")
                  : productPartId
                    ? productType === 0
                      ? t("Compose Product")
                      : t("Update Part")
                    : productType === 0
                      ? t("Compose Product")
                      : t("Add Part")}

                <p class="NrTextBorder px-3 mb-0 ms-auto">{t("Item ID")}</p>
                <p class="px-3 mb-0 ms-auto">{itemID}</p>
              </div>
            </Link>
          </div>
        }
      />
      {screenSize !== "xs" && (
        <div className="d-flex justify-content-between align-items-end p-0 pb-3 px-3">
          <div className="col-6"></div>
          <div className="d-flex justify-content-end gap-4 col-6 pr-3">
            <button
              onClick={cancelModal}
              className="products-and-parts-cancle-btn-aspect-ratio"
              style={{ wordBreak: "break-all" }}
            >
              {/* Cancel */}
              {t("Cancel")}
            </button>
            <button
              // onClick={addProduct}
              onClick={() => {
                addProduct();
                // addProductionEquipment();
              }}
              disabled={
                +stockData.minimum > +stockData.maximum ||
                isClicked ||
                isAddingProductionRow ||
                isValueExists ||
                (productType === 1 &&
                  !productList?.productpartsuppliers?.some(
                    (item) =>
                      // item?.supplierid && item?.suppliername && item?.itemid,
                      // skip supplier code in below
                      item?.supplierid && item?.suppliername,
                  )) ||
                isInvalid ||
                isSupplierCodeExist?.status
              }
              className="invitebtn-update products-and-parts-invite-btn-aspect-ratio btn-update"
              style={{ wordBreak: "break-all" }}
            >
              {/* {productPartId ? "Change" : "Add"} */}
              {productPartId ? t("Change") : t("Add")}
            </button>
          </div>
        </div>
      )}
      <div
        style={{ overflowX: "auto", marginRight: "15px", marginLeft: "27px" }}
      >
        <div className="products-and-parts-inputs pe-4 ps-3">
          {isBuildingBlock && (
            <div className="products-and-parts-asc-input-wrapper-container">
              {productList?.coverimage ? (
                <div className="product-image-default">
                  <img
                    src={productList.coverimage}
                    alt=""
                    className="cover-image"
                  />
                </div>
              ) : (
                <div className="product-image-default">
                  <img
                    src={
                      productList?.type === "Part"
                        ? addPart
                        : productList?.type === "Product"
                          ? Package
                          : productList?.type === "Service"
                            ? Setting
                            : ""
                    }
                    alt=""
                    style={{ width: "15px", height: "auto" }}
                  />
                  <div className="product-image-title">
                    {/* Picture */}
                    {t("Picture")}
                  </div>
                </div>
              )}
            </div>
          )}

          <div
            className="products-and-parts-asc-input-wrapper-container"
            id="products-and-parts-ascInput"
          >
            <label
              className={
                error || isValueExists
                  ? "errorLabel products-and-parts-asc-label-top products-and-parts-item-id-title"
                  : "products-and-parts-asc-label-top products-and-parts-item-id-title"
              }
            >
              {/* Item Code */}
              {t("Item Code ")} <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              // readOnly
              className={
                error || isValueExists
                  ? "product-input-error products-and-parts-item-id-input ps-2"
                  : "products-and-parts-item-id-input ps-2"
              }
              placeholder={t("Type an identifier")}
              name="productpartcode"
              value={productList.productpartcode}
              onChange={handleChange}
              // readOnly={productPartId}
              onBlur={() => {
                dispatch(
                  ProductpartBarCode({
                    itemid: productList.productpartcode,
                  }),
                ).then((res) => {
                  if (res.status === true) {
                    setBarCode(res.data.url);
                  }
                });
              }}
            />
            {isValueExists && (
              <p className="errorLabel ">
                {/* This ID already exist. Enter a new one. */}
                {t("This ID already exist. Enter a new one.")}
              </p>
            )}
          </div>

          <div
            className="products-and-parts-asc-input-wrapper-container"
            id="products-and-parts-ascInput"
          >
            <label
              className={
                itemNameError || isPartNameExist
                  ? "errorLabel products-and-parts-asc-label-top products-and-parts-item-id-title"
                  : "products-and-parts-asc-label-top products-and-parts-item-name-title"
              }
            >
              {/* Item Name */}
              {t("Item Name")} <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              className={
                itemNameError || isPartNameExist
                  ? "product-input-error products-and-parts-item-name-input"
                  : "products-and-parts-item-name-input"
              }
              style={{ width: "385px" }}
              placeholder={t("Type a name")}
              name="productpartname"
              value={productList.productpartname}
              onChange={handleChange}
            />
            {isPartNameExist && (
              <p className="errorLabel ">
                {/* This name already exist. Enter a new one. */}
                {t("This name already exist. Enter a new one.")}
              </p>
            )}
          </div>

          {/* TODO : Need to add € prefix here? */}
          <div
            className="products-and-parts-asc-input-wrapper-container"
            id="products-and-parts-ascInput"
          >
            <label className="products-and-parts-asc-label-top products-and-parts-item-sales-title">
              {/* Sales Price Exc. VAT */}
              {t("Sales Price Exc. VAT")}
            </label>

            <CurrencyInput
              className="products-and-parts-item-sales-input"
              placeholder="€ 0,00"
              name="salepriceexcvat"
              // value={productList.salepriceexcvat}
              value={
                productType === 0
                  ? totalQty + totalProductionCost
                  : productList.salepriceexcvat
              }
              onChangeEvent={(event, maskedvalue, floatvalue) => {
                let updateObject = {
                  name: "salepriceexcvat",
                  value: floatvalue,
                };
                handleChange({ target: updateObject });
              }}
              decimalSeparator=","
              thousandSeparator="."
              precision="2"
              allowEmpty={true}
              allowNegative
              prefix="€ "
            />
          </div>

          <div
            className="products-and-parts-asc-input-wrapper-container"
            id="products-and-parts-ascInput"
          >
            <label className="products-and-parts-asc-label-top products-and-parts-item-vat-title">
              {/* VAT % */}
              {t("VAT %")}
            </label>
            {/* <input
              type="number"
              className="products-and-parts-item-vat-input ps-3"
              placeholder="21,00"
              name="vatpercent"
              value={productList.vatpercent}
              onChange={handleChange}
            /> */}
            <input
              className="products-and-parts-item-sales-input"
              style={{ width: "100px" }}
              type="text"
              placeholder="€ 0,00"
              name="vatpercent"
              // value={
              //   productList.vatpercent !== ""
              //     ? `${europeanFormat(parseFloat(productList.vatpercent))} %`
              //     : "0,00 %"
              // }
              value={
                productList.vatpercent !== ""
                  ? `${productList.vatpercent} %`
                  : "%"
              }
              onChangeEvent={(e) => {
                handleChange(e);
              }}
              decimalSeparator=","
              thousandSeparator="."
              precision="2"
              allowEmpty={true}
              // prefix="€ "
            />
            <select
              className="dropdown-placeholder"
              value={productList.vatpercent}
              onChange={(e) =>
                handleChange({
                  target: { name: "vatpercent", value: e.target.value },
                })
              }
            >
              <option value="21">21</option>
              <option value="9">9</option>
              <option value="7">7</option>
              <option value="2">2</option>
              <option value="0">0</option>
            </select>
          </div>
        </div>

        {/* TAB SECTION */}

        <div className="products-and-parts-scroll-width pe-4 ps-3">
          <div className="row text-center pt-4 products-and-parts-table-div products-and-parts-scroll-width-22">
            <Tab
              label={t("General")}
              isActive={activeTab === "general"}
              onClick={() => handleTabClick("general")}
            />

            {isPlusPackage ||
              (isBuildingBlock && (
                <Tab
                  label={t("Images")}
                  isActive={activeTab === "images"}
                  onClick={() => handleTabClick("images")}
                />
              ))}

            {productType === 0 && (
              <Tab
                label={t("Composition")}
                isActive={activeTab === "composition"}
                onClick={() => handleTabClick("composition")}
              />
            )}

            {productType === 1 && (
              <Tab
                label={t("Suppliers")}
                isActive={activeTab === "suppliers"}
                onClick={() => handleTabClick("suppliers")}
                showAlert={showLowStockAlert}
              />
            )}

            {productType === 0 && (
              <Tab
                label={t("Production Steps")}
                isActive={activeTab === "ProductionSteps"}
                onClick={() => handleTabClick("ProductionSteps")}
              />
            )}

            <Tab
              label={t("Documents")}
              isActive={activeTab === "documents"}
              onClick={() => handleTabClick("documents")}
            />

            {/* {productType === 1 ? (
              <Tab
                label={FetchTranslationList[19]?.translation}
                isActive={activeTab === "partStock"}
                showAlert={showLowStockAlert}
                onClick={() => handleTabClick("partStock")}
              />
            ) : (
              <Tab
                label={FetchTranslationList[19]?.translation}
                isActive={activeTab === "composedProductStock"}
                onClick={() => handleTabClick("composedProductStock")}
              />
            )} */}

            {productType === 1 ? (
              <Tab
                label={t("Stock")}
                isActive={activeTab === "partStock"}
                showAlert={showLowStockAlert}
                onClick={() => handleTabClick("partStock")}
              />
            ) : productType !== 2 ? (
              <Tab
                label={t("Stock")}
                isActive={activeTab === "composedProductStock"}
                onClick={() => handleTabClick("composedProductStock")}
              />
            ) : null}
          </div>
        </div>

        <div
          className="products-and-parts-content pe-4 py-4 ps-3"
          style={{ overflowX: "unset", height: "auto" }}
        >
          {/* General Tab */}
          {activeTab === "general" && (
            <div className="products-and-parts-general-tab align-items-start">
              {/* General Tab : Section 1 */}
              <div className="">
                <div
                  className="products-and-parts-asc-input-container-general-section-1"
                  id="products-and-parts-ascInput"
                >
                  <label className="products-and-parts-asc-label-top products-and-parts-item-description-title">
                    {/* Item Description */}
                    {t("Item Description")}
                  </label>
                  <textarea
                    id="itemdescription"
                    rows="10"
                    cols="20"
                    className="products-and-parts-tab-item-description-input ps-4"
                    placeholder={t("Add a description")}
                    name="itemdescription"
                    value={productList.itemdescription}
                    onChange={handleChange}
                  ></textarea>
                </div>

                <div className="d-flex justify-content-between align-items-baseline">
                  {productType !== 2 && (
                    <div style={{ position: "relative" }}>
                      <div
                        className="products-and-parts-asc-input-container-general-section-1 products-and-parts-icon-plus-input-container"
                        id="products-and-parts-ascInput"
                      >
                        <label className="products-and-parts-asc-label-top products-and-parts-item-colors-title">
                          {/* Colors */}
                          {t("Colors")}
                        </label>
                      </div>
                      <ColorPickers
                        colors={productList.productpartvariation}
                        handleChange={handleChange}
                      />
                    </div>
                  )}

                  {/* Unit section start */}
                  <div
                    className="products-and-parts-asc-input-wrapper-container mt-4"
                    id="ascInput"
                  >
                    <label className="asc-label-top ClientNameText">
                      {/* Units */}
                      {t("Units")}
                    </label>
                    <div
                      className="asc_Client_Input_Div_For_LongDiv22"
                      ref={filter_Popup_Ref}
                      style={{ width: "220px" }}
                    >
                      <input
                        type="text"
                        className="asc_Client_Input_For_Long ps-3"
                        // style={{ width: "80%" }}
                        placeholder="Select Unit"
                        value={unitName}
                        onChange={(e) => {
                          setUnitName(e.target.value);
                        }}
                        onFocus={() => {
                          setUnitOptions(true);
                          setArrowOptionsRotate(true);
                        }}
                      />

                      {unitName ? (
                        <img
                          src={Xicon}
                          className="xicon pointer"
                          alt=""
                          onClick={() => {
                            setUnitName("");
                            setUnitID("");
                            // setTypeComp("asc");
                          }}
                        />
                      ) : // <img
                      //   src={DownArrowOption}
                      //   className={arrowOptionsRotate ? "upArrow" : "downArrow"}
                      //   alt=""
                      //   onClick={() => {
                      //     setUnitOptions(true);
                      //     setArrowOptionsRotate(true);
                      //   }}
                      // />
                      null}

                      {unitOptions && (
                        <div
                          className="asc_Custom_Select_Outer22"
                          style={{
                            top: "-32px",
                            overflow: "auto",
                            maxHeight: "115px",
                          }}
                        >
                          <p className="asc_Search_Client_Text pt-2 ps-2">
                            Select Unit
                            {/* {FetchTranslationList[165]?.translation} */}
                          </p>

                          <section
                            className="asc_Search_List pt-0 p-3"
                            id="ascSelectBox"
                          >
                            {unitData.map((item, index) => {
                              return (
                                <div
                                  key={index}
                                  className=""
                                  onClick={() => {
                                    setUnitName(item.unitname);
                                    setUnitID(item.unitid);
                                    setUnitOptions(false);
                                    // setTypeComp("asc");
                                  }}
                                >
                                  {item.unitname}
                                </div>
                              );
                            })}
                            {unitData.length === 0 && (
                              <span className="noDataDisplay">
                                No data to display!
                                {/* {FetchTranslationList?.data?.data[94]?.translation} */}
                              </span>
                            )}
                          </section>
                        </div>
                      )}
                    </div>
                  </div>
                  {/* Unit section end */}
                </div>
              </div>

              {/* General Tab : Section 2 */}
              <div className="">
                {productType !== 2 && (
                  <div
                    className="products-and-parts-asc-input-container-general-section-2 products-and-parts-dimensions-wrapper"
                    id="products-and-parts-ascInput"
                    style={{ height: "170px" }}
                  >
                    <label className="products-and-parts-asc-label-top products-and-parts-item-dimensions-title">
                      {/* Dimensions (mm) */}
                      {t("Dimentions")} (mm)
                    </label>
                    <div className="products-and-parts-inner-container-wrappe-r">
                      <div className="d-flex justify-content-around">
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                          <input
                            type="number"
                            className="products-and-parts-tab-dimensions-input"
                            placeholder="0"
                            name="width"
                            value={productList.width}
                            onChange={handleChange}
                          />
                          <p className="products-and-parts-dimensions-labels">
                            {/* Width */}
                            {t("Width")}
                          </p>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <input
                            type="number"
                            className="products-and-parts-tab-dimensions-input"
                            placeholder="0"
                            name="heigth"
                            value={productList.heigth}
                            onChange={handleChange}
                          />
                          <p className="products-and-parts-dimensions-labels">
                            {/* Height */}
                            {t("Height")}
                          </p>
                        </div>
                      </div>

                      <div className="d-flex justify-content-around mt-4">
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                          <input
                            type="number"
                            className="products-and-parts-tab-dimensions-input"
                            placeholder="0"
                            name="depth"
                            value={productList.depth}
                            onChange={handleChange}
                          />
                          <p className="products-and-parts-dimensions-labels">
                            {/* Depth */}
                            {t("Depth")}
                          </p>
                        </div>

                        {/* {productType === 1 && (
                          
                        )} */}
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                          <EuroFormat
                            placeholder="0"
                            value={productList.productWeight}
                            formatType="number"
                            className="products-and-parts-tab-dimensions-input"
                            name="productWeight"
                            onChange={handleChange}
                          />
                          <p className="products-and-parts-dimensions-labels">
                            {/* Weight */}
                            {t("Weight")}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <div className="products-and-parts-asc-input-container-general-section-2">
                  <label
                    className="products-and-parts-asc-label-top products-and-parts-item-brand-title position-absolute"
                    style={{ zIndex: 1 }}
                  >
                    {t("Location Specifications")}
                  </label>
                  <div className="count-orders-wrp">
                    <div className="location-wrp">
                      <input
                        type="text"
                        className="products-and-parts-tab-dimensions-input"
                        placeholder="0"
                        name="aisle"
                        value={productList.aisle}
                        onChange={handleChange}
                      />
                      <span>{t("Aisle")}</span>
                    </div>
                    <div className="location-wrp">
                      <input
                        type="text"
                        className="products-and-parts-tab-dimensions-input"
                        placeholder="0"
                        name="row"
                        value={productList.row}
                        onChange={handleChange}
                      />
                      <span>{t("Row")}</span>
                    </div>
                    <div className="location-wrp">
                      <input
                        type="text"
                        className="products-and-parts-tab-dimensions-input"
                        placeholder="0"
                        name="bin"
                        value={productList.bin}
                        onChange={handleChange}
                      />
                      <span>{t("Bin")}</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* General Tab : Section 3 */}
              <div>
                {productType !== 2 && (
                  <div
                    className="products-and-parts-asc-input-container-general-section-2"
                    id="products-and-parts-ascInput"
                    style={{ position: "relative" }}
                  >
                    <label className="products-and-parts-asc-label-top products-and-parts-item-categories-title">
                      {t("Barcode")}
                    </label>
                    <div className="barcodebox ps-">
                      <img
                        src={barCode}
                        alt=""
                        style={{ width: "100%", height: "80px" }}
                      />
                    </div>
                  </div>
                )}

                <div
                  className="products-and-parts-asc-input-container-general-section-2"
                  id="products-and-parts-ascInput"
                  style={{ position: "relative" }}
                >
                  <label className="products-and-parts-asc-label-top products-and-parts-item-categories-title">
                    {/* Categories */}
                    {t("Categories")}
                  </label>
                  <textarea
                    className="products-and-parts-tab-categories-input ps-4"
                    // placeholder="Type or select Category"
                    placeholder={t("Type or select categories")}
                    name="categories"
                    value={productCategoryList}
                    // onKeyUp={handleCategoryEnter}
                    onKeyUp={(e) => {
                      handleCategoryEnter_ASC(e);
                    }}
                    onChange={(e) => {
                      setProductCategoryList(e.target.value);
                    }}
                    onFocus={(e) => {
                      setCategoriesBoxOpen(true);
                    }}
                    onBlur={() => {
                      setTimeout(() => {
                        setCategoriesBoxOpen(false);
                      }, 500);
                    }}
                  />
                  {categoriesBoxOpen && (
                    <div className="categoriesBox mx-1">
                      <div className="d-flex p-2">
                        <p className="mb-0 text-muted">
                          {/* Select categories... */}
                          {t("Select categories...")}
                        </p>
                        <img
                          src={XCircle}
                          alt=""
                          className="ms-auto crossProduct"
                          style={{ width: "18px" }}
                          onClick={() => {
                            setCategoriesBoxOpen(false);
                          }}
                        />
                      </div>
                      {categoriesData.map((cat, index) => {
                        return (
                          <div className="ulterDrop">
                            <p
                              className={
                                pillList.some(
                                  (item) =>
                                    item.ascCategoriesName === cat.categories,
                                )
                                  ? "mb-0 pointerEvent"
                                  : "mb-0 pointer"
                              }
                              onClick={() => {
                                // setProductCategoryList(cat.categories);
                                let data = [...pillList];
                                data.push({
                                  ascCategoriesName: cat.categories,
                                });
                                setPillList(data);
                                // setProductCategoryList("");

                                setCategoriesBoxOpen(false);
                              }}
                            >
                              {cat.categories}
                            </p>
                          </div>
                        );
                      })}
                      {categoriesData.length === 0 && (
                        <span>No categories to display!</span>
                      )}
                    </div>
                  )}

                  <div className="categoriesTgedNameBox">
                    {pillList.map((pill, index) => {
                      return (
                        <>
                          <div className="categoriesTgedName mb-1">
                            <p className="mb-0 pe-2 borderRight p-0">
                              {pill.ascCategoriesName}
                            </p>
                            <img
                              src={Xicon}
                              alt=""
                              className="ms-auto crossProduct"
                              onClick={() => {
                                let data = [...pillList];
                                data.splice(index, 1);
                                setPillList(data);
                              }}
                            />
                          </div>
                        </>
                      );
                    })}
                  </div>

                  {/* <div className="products-and-parts-nav-pills">
                    {pillList[0]?.length > 0 && (
                      <div className="products-and-parts-pill">
                        {pillList[0]}
                        <button
                          className="products-and-parts-remove-pill"
                          onClick={() => removeCategoriesItems(0)}
                        >
                          X
                        </button>
                      </div>
                    )}
                    {pillList?.slice(1).map((pill, index) => (
                      <div key={index + 1} className="products-and-parts-pill">
                        {pill}
                        <button
                          className="products-and-parts-remove-pill"
                          onClick={() => removeCategoriesItems(index + 1)}
                        >
                          X
                        </button>
                      </div>
                    ))}
                  </div> */}
                </div>

                <div
                  className="products-and-parts-asc-input-container-general-section-2"
                  id="products-and-parts-ascInput"
                >
                  <label
                    className="products-and-parts-asc-label-top products-and-parts-item-brand-title"
                    style={{ zIndex: 1 }}
                  >
                    {/* Brand */}
                    {t("Brand")}
                  </label>
                  <div
                    className={`${
                      showBrandOptions
                        ? "products-and-parts-tab-brand-input-expanded ps-3"
                        : "products-and-parts-tab-brand-input ps-3"
                    }`}
                  >
                    <input
                      type="text"
                      // placeholder={`${showBrandOptions ? "Type a Brand" : "Add a Brand"}`}
                      placeholder={`${
                        showBrandOptions ? "Type a Brand" : t("Add a Brand")
                      }`}
                      className="products-and-parts-brand-text"
                      value={productList.brand}
                      name="brand"
                      onChange={(e) => {
                        handleChange({
                          target: { name: "brand", value: e.target.value },
                        });
                        setShowBrandXIcon(true);
                      }}
                      onFocus={() => {
                        setShowBrandOptions(true);
                        setShowHealthOptions(false);
                        setShowApplicationOptions(false);
                      }}
                      onBlur={() => {
                        setShowBrandOptions(false);
                      }}
                    />

                    {productList.brand?.length > 0 && (
                      <img
                        src={Xicon}
                        className="pointer"
                        alt=""
                        onClick={() => {
                          handleChange({
                            target: { name: "brand", value: "" },
                          });
                          setShowBrandOptions(true);
                          setShowBrandXIcon(false);
                        }}
                      />
                    )}

                    {showBrandOptions && (
                      <div className="products-and-parts-brand-customSelect_Outer ps-0">
                        {brand2
                          .filter((item) =>
                            item?.brand
                              ?.toLowerCase()
                              .includes(productList?.brand.toLowerCase()),
                          )
                          .map((item, index) => {
                            return (
                              <div
                                key={index}
                                name="brand"
                                className="products-and-parts-pointer products-and-parts-dropdown-spacing ulterDrop"
                                onMouseDown={(e) => e.preventDefault()}
                                onClick={() => {
                                  setShowBrandOptions(false);
                                  setShowBrandXIcon(true);
                                  handleChange({
                                    target: {
                                      name: "brand",
                                      value: item?.brand,
                                    },
                                  });
                                }}
                              >
                                {item?.brand}
                              </div>
                            );
                          })}
                        {brand2.length === 0 && (
                          <span className="noDataDisplay">
                            {/* No data to display! */}
                            {t("No data to display!")}
                          </span>
                        )}
                      </div>
                    )}
                  </div>
                </div>

                {productType === 2 && (
                  <div
                    className="products-and-parts-asc-input-container-general-section-2"
                    id="products-and-parts-ascInput"
                  >
                    <label
                      className="products-and-parts-asc-label-top products-and-parts-item-brand-title"
                      style={{ zIndex: 1 }}
                    >
                      {/* Health */}
                      {t("Health")}
                    </label>
                    <div
                      className={`${
                        showHealthOptions
                          ? "products-and-parts-tab-brand-input-expanded ps-3"
                          : "products-and-parts-tab-brand-input ps-3"
                      }`}
                    >
                      <input
                        type="text"
                        // placeholder={`${showHealthOptions ? "Type a Designation" : "Add a Designation"
                        //   }`}
                        placeholder={`${
                          showHealthOptions
                            ? "Type a Designation"
                            : t("Add a Designation")
                        }`}
                        className="products-and-parts-brand-text"
                        value={productList?.health}
                        name="health"
                        onChange={(e) => {
                          handleChange({
                            target: { name: "health", value: e.target.value },
                          });
                          setShowHealthXIcon(true);
                        }}
                        onFocus={() => {
                          setShowHealthOptions(true);
                          setShowBrandOptions(false);
                          setShowApplicationOptions(false);
                        }}
                        onBlur={() => {
                          setShowHealthOptions(false);
                        }}
                      />

                      {productList?.health?.length > 0 && (
                        <img
                          src={Xicon}
                          className="pointer"
                          alt=""
                          onClick={() => {
                            handleChange({
                              target: { name: "health", value: "" },
                            });
                            setShowHealthOptions(true);
                            setShowHealthXIcon(false);
                          }}
                        />
                      )}

                      {showHealthOptions && (
                        <div className="products-and-parts-brand-customSelect_Outer ps-0">
                          {health2
                            .filter((item) =>
                              item?.health
                                ?.toLowerCase()
                                .includes(productList?.health.toLowerCase()),
                            )
                            .map((item, index) => {
                              return (
                                <div
                                  key={index}
                                  name="health"
                                  className="products-and-parts-pointer products-and-parts-dropdown-spacing ulterDrop"
                                  onMouseDown={(e) => e.preventDefault()}
                                  onClick={() => {
                                    setShowHealthOptions(false);
                                    setShowHealthXIcon(true);
                                    handleChange({
                                      target: {
                                        name: "health",
                                        value: item?.health,
                                      },
                                    });
                                  }}
                                >
                                  {item?.health}
                                </div>
                              );
                            })}
                          {health2.length === 0 && (
                            <span className="noDataDisplay">
                              {/* No data to display! */}
                              {t("No data to display!")}
                            </span>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                )}

                <div
                  className="products-and-parts-asc-input-container-general-section-2"
                  id="products-and-parts-ascInput"
                >
                  <label
                    className="products-and-parts-asc-label-top products-and-parts-item-brand-title"
                    style={{ zIndex: 1 }}
                  >
                    {/* Application */}
                    {t("Application")}
                  </label>
                  <div
                    className={`${
                      showApplicationOptions
                        ? "products-and-parts-tab-brand-input-expanded ps-3"
                        : "products-and-parts-tab-brand-input ps-3"
                    }`}
                  >
                    <input
                      type="text"
                      // placeholder={`${showApplicationOptions ? "Type a Designation" : "Add a Designation"
                      //   }`}
                      placeholder={`${
                        showHealthOptions
                          ? "Type a Designation"
                          : t("Add a Designation")
                      }`}
                      className="products-and-parts-brand-text"
                      value={productList.application}
                      name="application"
                      onChange={(e) => {
                        handleChange({
                          target: {
                            name: "application",
                            value: e.target.value,
                          },
                        });
                        setShowApplicationXIcon(true);
                      }}
                      onFocus={() => {
                        setShowApplicationOptions(true);
                        setShowBrandOptions(false);
                        setShowHealthOptions(false);
                      }}
                      onBlur={() => {
                        setShowApplicationOptions(false);
                      }}
                    />

                    {productList.application?.length > 0 && (
                      <img
                        src={Xicon}
                        className="pointer"
                        alt=""
                        onClick={() => {
                          handleChange({
                            target: { name: "application", value: "" },
                          });
                          setShowApplicationOptions(true);
                          setShowApplicationXIcon(false);
                        }}
                      />
                    )}

                    {showApplicationOptions && (
                      <div className="products-and-parts-brand-customSelect_Outer ps-0">
                        {application2
                          .filter((item) =>
                            item?.application
                              ?.toLowerCase()
                              .includes(productList.application.toLowerCase()),
                          )
                          .map((item, index) => {
                            return (
                              <div
                                key={index}
                                name="application"
                                className="products-and-parts-pointer products-and-parts-dropdown-spacing ulterDrop"
                                onMouseDown={(e) => e.preventDefault()}
                                onClick={() => {
                                  setShowApplicationOptions(false);
                                  setShowApplicationXIcon(true);
                                  handleChange({
                                    target: {
                                      name: "application",
                                      value: item?.application,
                                    },
                                  });
                                }}
                              >
                                {item?.application}
                              </div>
                            );
                          })}
                        {application2.length === 0 && (
                          <span className="noDataDisplay">
                            {/* No data to display! */}
                            {t("No data to display!")}
                          </span>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* images tab */}
          {activeTab === "images" && (
            <ProductImagesBB
              productList={productList}
              setProductList={setProductList}
            />
          )}

          {/* Composition tab */}
          {activeTab === "composition" && (
            <ProductComposition
              setTotalQty={(val) => setTotalQty(val)}
              totalQty={totalQty}
              compositionData={compositionData}
              setCompositionData={setCompositionData}
              listData={listData}
              setListData={setListData}
              clientSearch={clientSearch}
              setClientSearch={setClientSearch}
              FetchTranslationList={FetchTranslationList}
            />
          )}

          {/* suppliers Tab */}
          {activeTab === "suppliers" && (
            <div
              ref={supplierDropdownContainerRef}
              style={{ marginTop: "clamp(20px, 1.406vw, 1.406vw)" }}
            >
              <div className="products-and-parts-stock-tab">
                {/* Stock Tab : Section 1 */}
                {/* <div className="products-and-parts-toggle-area col-8">
                  <label>
                    {FetchTranslationList[34]?.translation}
                  </label>
                  <input
                    type="checkbox"
                    id="products-and-parts-switch1"
                    className="checkbox"
                    name="partoftheproduct"
                    checked={productList.partoftheproduct}
                    value={productList.partoftheproduct}
                    onChange={handleChangeCheckbox}
                  />
                  <label
                    htmlFor="products-and-parts-switch1"
                    className="toggle"
                  ></label>
                </div> */}
                {/* Stock Tab : Section 2 */}
                {/* <div className="products-and-parts-toggle-area col-4">
                  <label>
                    {FetchTranslationList[45]?.translation}
                  </label>
                  <input
                    type="checkbox"
                    id="products-and-parts-switch2"
                    className="checkbox"
                    name="stockmanagement"
                    checked={productList.stockmanagement}
                    value={productList.stockmanagement}
                    onChange={handleChangeCheckbox}
                  />
                  <label
                    htmlFor="products-and-parts-switch2"
                    className="toggle"
                  ></label>
                </div> */}
              </div>

              {/* Stock Tab : Section 1 */}
              {productList?.productpartsuppliers?.map((item, index) => {
                const isCurrentSupplierError =
                  isSupplierCodeExist?.status &&
                  isSupplierCodeExist?.suppCodeIndex === index;
                return (
                  <div key={index} className="products-and-parts-stock-tab">
                    <div className="products-and-parts-toggle-area col-8">
                      <div
                        className="products-and-parts-asc-input-container"
                        id="products-and-parts-ascInput"
                      >
                        <label className="products-and-parts-asc-label-top products-and-parts-supplier-title">
                          {/* Supplier */}
                          {t("Supplier")}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <div
                          className={`${
                            item.showSupplierOptions
                              ? "products-and-parts-tab-supplier-input-expanded ps-3"
                              : "products-and-parts-tab-supplier-input ps-3"
                          }`}
                          // ref={refTypeDropDownContainer}
                        >
                          <input
                            type="text"
                            // placeholder={`${item.showSupplierOptions ? "Select a Supplier" : "Add a Supplier"
                            //   }`}
                            placeholder={`${
                              item.showSupplierOptions
                                ? "Select a Supplier"
                                : t("Add a Supplier")
                            }`}
                            readOnly
                            className="products-and-parts-supplier-text"
                            value={item.searchSupplierName || item.suppliername}
                            name={`supplierid-${index}`}
                            onChange={(e) => {
                              handleStockData(index, e, "showOptions");
                            }}
                            onBlur={() => {
                              setTimeout(() => {
                                handleStockData(index, null, "hideOptions");
                              }, 500);
                            }}
                            onClick={() => {
                              handleStockData(index, null, "showOptions");
                            }}
                          />

                          {item.showSupplierXIcon && (
                            <img
                              src={Xicon}
                              className="pointer"
                              alt=""
                              onClick={() => {
                                handleStockData(index, null, "hideOptions");
                                handleStockData(index, null, "hideXIcon");
                              }}
                            />
                          )}
                          {item.showSupplierOptions && (
                            <div
                              ref={refTypeDropDownContainerExclude}
                              className="products-and-parts-supplier-customSelect_Oute-r newSupplierDropdownBox shadow"
                            >
                              <div className="part-modal-header d-flex align-items-center justify-content-between">
                                <span className="add-part-bold">
                                  {/* Supplier */}
                                  {t("Supplier")}
                                </span>
                                <div className="client-search-main-product w-50">
                                  <input
                                    type="text"
                                    value={supplierSearch}
                                    style={{
                                      width: "90%",
                                      margin: "0 0 0 0.5rem",
                                      fontSie: "14px",
                                      fontWeight: clientSearch ? "400" : "300",
                                      color: clientSearch ? "" : "black",
                                    }}
                                    // placeholder="Search"
                                    placeholder={t("Search")}
                                    className="search-style select-client-div"
                                    onChange={(e) => {
                                      setSupplierSearch(e.target.value);
                                      localStorage.setItem(
                                        "newSupplierIndex",
                                        index,
                                      );
                                    }}
                                  />
                                  <img
                                    alt=""
                                    className="mb-1 search_pop"
                                    src={searchIcon}
                                  />
                                </div>

                                <div
                                  className="d-flex gap-2 pointer align-center"
                                  onClick={() => {
                                    // history.push("/add-supplier");
                                    history.push({
                                      pathname: "/add-supplier",
                                      // search: "?from=asc",
                                      state: "",
                                      from: "addProduct_Screen",
                                    });
                                    localStorage.setItem(
                                      "Active_supplier_Tab",
                                      true,
                                    );
                                  }}
                                >
                                  <img src={AddButton} alt="" />
                                  <p className="mb-0">Add Supplier</p>
                                </div>
                              </div>
                              <div className="newSupplierDropdown add-part-list">
                                {supplier
                                  .filter((x) =>
                                    x.suppliername
                                      ?.toLowerCase()
                                      .includes(supplierSearch.toLowerCase()),
                                  )
                                  .map((innerItem, ind) => {
                                    return (
                                      <div
                                        key={ind}
                                        className="products-and-parts-pointer products-and-parts-dropdown-spacing d-flex gap-4"
                                        onClick={() => {
                                          handleStockData(
                                            index,
                                            innerItem,
                                            "selectSupplier",
                                          );
                                          setSupplierSearch("");
                                        }}
                                        style={{
                                          borderTop: "1px dashed #7e7e7e",
                                          backgroundColor:
                                            innerItem.suppliername ===
                                            item.suppliername
                                              ? "#F4F5F4"
                                              : "transparent",
                                        }}
                                      >
                                        <p className="mb-0 w-50">
                                          {innerItem.suppliername}
                                        </p>
                                        <p className="mb-0">
                                          {innerItem.email || "email"}
                                        </p>
                                      </div>
                                    );
                                  })}
                              </div>
                              {supplier.length === 0 && (
                                <span className="noDataDisplay">
                                  {/* No data to display! */}
                                  {t("No data to display!")}
                                </span>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                      {/* Item ID */}
                      <div
                        className="products-and-parts-asc-input-container products-and-parts-icon-plus-input-container"
                        id="products-and-parts-ascInput"
                      >
                        <label className="products-and-parts-asc-label-top products-and-parts-item-id-title">
                          {/* Supplier ID */}
                          {t("Supplier ID")}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        {/* {!item.itemid && (
                        <img
                          src={plusDottedIcon}
                          alt="Plus Icon"
                          className="products-and-parts-plus-dotted-icon-centered"
                        />
                      )} */}
                        <input
                          type="text"
                          className="products-and-parts-stock-inputs products-and-parts-stock-item-id-input ps-4"
                          value={item.itemid}
                          name="itemid"
                          onChange={(e) => {
                            handleStockData(index, e);
                            handleSupplierIdChange(index, e.target.value);
                          }}
                          style={{
                            // border: fieldErrors?.[index]?.itemid
                            //   ? "1px solid red"
                            //   : "",
                            border: isCurrentSupplierError
                              ? "1px solid red"
                              : "",
                          }}
                        />
                        {isCurrentSupplierError && (
                          <p className="errorLabel ">
                            {/* Supplier id already exist */}
                            {t(" Supplier id already exist")}
                          </p>
                        )}
                      </div>

                      <div
                        className="products-and-parts-asc-input-container products-and-parts-icon-plus-input-container"
                        id="products-and-parts-ascInput"
                      >
                        <label className="products-and-parts-asc-label-top products-and-parts-item-cost-price-title">
                          {/* Cost Price */}
                          {t("Cost Price")}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <CurrencyInput
                          className="products-and-parts-stock-inputs products-and-parts-lead-time-input"
                          placeholder="0"
                          name="costprice"
                          value={item.costprice}
                          onChangeEvent={(e) => {
                            handleStockData(index, e);
                          }}
                          decimalSeparator=","
                          thousandSeparator="."
                          precision="2"
                          allowEmpty={true}
                          prefix="€ "
                          style={{
                            border: fieldErrors?.[index]?.costprice
                              ? "1px solid red"
                              : "",
                          }}
                        />
                      </div>
                      <div
                        className="products-and-parts-asc-input-container"
                        id="products-and-parts-ascInput"
                      >
                        <label className="products-and-parts-asc-label-top products-and-parts-lead-time-title">
                          {/* Lead Time */}
                          {t("Lead Time")}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="number"
                          className="products-and-parts-stock-inputs products-and-parts-lead-time-input"
                          placeholder="0"
                          value={item.leadtime}
                          name="leadtime"
                          onChange={(e) => handleStockData(index, e)}
                          style={{
                            border: fieldErrors?.[index]?.leadtime
                              ? "1px solid red"
                              : "",
                          }}
                        />
                      </div>
                      <div
                        className="products-and-parts-del-img"
                        onClick={() => handleDeleteSupplier(index)}
                      >
                        <Tooltip title="Delete" color={"red"}>
                          <img
                            src={DeleteIcon}
                            className="pb-2 products-and-parts-pointer"
                            alt=""
                          />
                        </Tooltip>
                      </div>
                      {item.lowStock && (
                        <MakePurchaseTooltip classes="mt-5 ms-4" />
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          {/* Production Steps Tab */}
          {activeTab === "ProductionSteps" && (
            <div className="production-scroll" style={{ height: "80vh" }}>
              {/* Summary */}
              <div className="production-summary">
                <div>
                  <span>{t("TOTAL PRODUCTION TIME")}</span>
                  <strong>{`${totalProductionTime} Minutes`}</strong>
                </div>

                <div>
                  <span>{t("TOTAL PRODUCTION COST")}</span>
                  <strong>
                    {europeanFormatWithSymbol(totalProductionCost)}
                  </strong>
                </div>

                <div>
                  <span>{t("TOTAL PRODUCTION CO₂")}</span>
                  <strong>{`${totalProductionCO2} kg`}</strong>
                </div>
              </div>

              {/* Production Rows Section */}
              <div className="production-scroll-old">
                <div className="production-rows">
                  {/* Row */}
                  {productionRows.map((row, prodIndex) => {
                    return (
                      <div
                        className="production-row mt-3"
                        key={row.partEquipmentid || row.rowId}
                      >
                        <div className="production-field">
                          <label>
                            {t("Equipment")}
                            <span>*</span>
                          </label>
                          <input
                            type="text"
                            placeholder={t("Type equipment")}
                            readOnly
                            value={row.equipment}
                            onClick={(e) => {
                              setToggleEquipment(
                                row.partEquipmentid || row.rowId,
                              );
                              setAnchorEl(e.currentTarget);
                            }}
                            onChange={(e) =>
                              updateField(
                                prodIndex,
                                "equipment",
                                e.target.value,
                              )
                            }
                          />
                          {toggleEquipment ===
                            (row.partEquipmentid || row.rowId) && (
                            <Popper
                              open={Boolean(anchorEl)}
                              anchorEl={anchorEl}
                              placement="auto"
                              style={{ zIndex: 9999 }}
                            >
                              <TaskEquipmentList
                                setToggleEquipment={toggleEquipmentFun}
                                selectedEquipments={
                                  selectedEquipmentsByRow[prodIndex] || []
                                }
                                setSelectedEquipments={(equipments) =>
                                  setSelectedEquipmentsByRow((prev) => {
                                    const updatedSelections = [...prev];
                                    updatedSelections[prodIndex] = equipments;
                                    return updatedSelections;
                                  })
                                }
                                singleSelect
                                onApply={(equipments) => {
                                  const selectedEquipment = equipments[0];

                                  updateField(
                                    prodIndex,
                                    "equipment",
                                    selectedEquipment?.equipmentname || "",
                                  );
                                  updateField(
                                    prodIndex,
                                    "equipmentid",
                                    selectedEquipment?.equipmentid || "",
                                  );
                                  updateField(
                                    prodIndex,
                                    "timeUnit",
                                    selectedEquipment?.timeUnit || "",
                                  );

                                  updateField(
                                    prodIndex,
                                    "timeUnitPrice",
                                    selectedEquipment?.timeUnitPrice || "",
                                  );
                                }}
                                style={{ left: "1px", position: "unset" }}
                              />
                            </Popper>
                          )}
                        </div>

                        <div className="production-field">
                          <label>
                            {/* {t("Process")} */}
                            {t("Activity")}
                            <span>*</span>
                          </label>
                          <input
                            type="text"
                            placeholder={t("Type process")}
                            value={row.process}
                            onChange={(e) =>
                              updateField(prodIndex, "process", e.target.value)
                            }
                          />
                        </div>

                        <div className="production-field">
                          <label>{t("Time unit")}</label>
                          <input
                            readOnly
                            placeholder={t("Time unit")}
                            value={row.timeUnit}
                          />
                          {/* <select
                            value={row.timeUnit}
                            onChange={(e) =>
                              updateField(prodIndex, "timeUnit", e.target.value)
                            }
                          >
                            <option value="">Select</option>
                            <option value="Minutes">Minutes</option>
                            <option value="One-Off">One-Off</option>
                          </select> */}
                        </div>

                        <div className="production-field">
                          <label> {t("Setup Time")}</label>
                          <input
                            type="text"
                            readOnly={row?.timeUnit === "One-Off"}
                            placeholder={"—"}
                            value={row.setupTime}
                            onChange={(e) =>
                              updateField(
                                prodIndex,
                                "setupTime",
                                e.target.value,
                              )
                            }
                          />
                        </div>

                        <div className="production-field">
                          <label>{t("Run Time")}</label>
                          <input
                            type="text"
                            readOnly={row?.timeUnit === "One-Off"}
                            placeholder={"—"}
                            value={row.runTime}
                            onChange={(e) =>
                              updateField(prodIndex, "runTime", e.target.value)
                            }
                          />
                        </div>

                        <div className="production-field">
                          <label>{t("Time Unit Price")}</label>
                          {/* <input
                            type="text"
                            value={row.timeUnitPrice}
                            onChange={(e) =>
                              updateField(
                                row.id,
                                "timeUnitPrice",
                                e.target.value,
                              )
                            }
                          /> */}
                          <CurrencyInput
                            className="products-and-parts-stock-inputs products-and-parts-lead-time-input"
                            placeholder="0"
                            name="costprice"
                            readOnly
                            value={row.timeUnitPrice}
                            onChange={(e, value) =>
                              updateField(prodIndex, "timeUnitPrice", value)
                            }
                            decimalSeparator=","
                            thousandSeparator="."
                            precision="2"
                            allowEmpty={true}
                            prefix="€ "
                            // style={{
                            //   border: fieldErrors?.[index]?.costprice
                            //     ? "1px solid red"
                            //     : "",
                            // }}
                          />
                        </div>

                        <div className="production-field">
                          <label>{t("Total Cost")}</label>
                          {/* <input
                            type="text"
                            readOnly
                          /> */}
                          <CurrencyInput
                            className="products-and-parts-stock-inputs products-and-parts-lead-time-input"
                            placeholder="0"
                            name="costprice"
                            readOnly
                            value={row.totalEquipCost}
                            onChange={(e, value) =>
                              updateField(prodIndex, "totalEquipCost", value)
                            }
                            decimalSeparator=","
                            thousandSeparator="."
                            precision="2"
                            allowEmpty={true}
                            prefix="€ "
                            // style={{
                            //   border: fieldErrors?.[index]?.costprice
                            //     ? "1px solid red"
                            //     : "",
                            // }}
                          />
                        </div>

                        <div className="production-field">
                          <label>{t("CO₂")}</label>
                          <input
                            type="text"
                            value={row.co2}
                            onChange={(e) =>
                              updateField(prodIndex, "co2", e.target.value)
                            }
                          />
                        </div>

                        {prodIndex !== productionRows.length - 1 && (
                          <button
                            type="button"
                            className="border-0 bg-transparent"
                            title="Remove row"
                            onClick={() => {
                              removeRow(prodIndex, row?.partEquipmentid);
                            }}
                            disabled={productionRows.length === 1}
                          >
                            <img src={DeleteIcon} className="" alt="" />
                          </button>
                        )}

                        {prodIndex === productionRows.length - 1 && (
                          <div
                            className="production-add"
                            title="Add row"
                            aria-disabled={isAddingProductionRow}
                            onClick={() => {
                              if (
                                isAddingProductionRow ||
                                !row?.equipment ||
                                !row?.process
                              )
                                return;
                              addProdRow();
                            }}
                          >
                            +
                          </div>
                        )}
                      </div>
                    );
                  })}
                  {productionRowError && (
                    <div role="alert" className="text-danger mt-2">
                      {t(productionRowError)}
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          {/* Composed Product stock  tab */}
          {activeTab === "composedProductStock" && (
            <ComposedProductStock
              stockData={stockData}
              setStockData={setStockData}
              totalQty={totalQty}
              productionHistory={productionHistory}
              minMaxError={minMaxError}
              FetchTranslationList={FetchTranslationList}
            />
          )}

          {/* parts stock  tab */}
          {activeTab === "partStock" && (
            <PartStock
              stockData={stockData}
              setStockData={setStockData}
              productionHistory={productionHistory}
              productList={productList}
              minMaxError={minMaxError}
              FetchTranslationList={FetchTranslationList}
            />
          )}

          {/* Document Tab */}
          {activeTab === "documents" && (
            <div className="products-and-parts-doc-tab-container">
              <StockDocumentsTab />
            </div>
          )}
        </div>
      </div>

      {modal && (
        <CancelWarningModal
          show={modal}
          onHide={() => showModal(false)}
          backdrop="static"
          keyboard={false}
          handleCancel={handleCancel}
        />
      )}

      <RouteLeavingGuard
        when={typeInScreen !== ""}
        navigate={(path) => history.push(path)}
        shouldBlockNavigation={(location) => {
          if (typeInScreen !== "") {
            if (
              ![
                "/productsList",
                "/add-part",
                "/add-product",
                "/add-service",
              ].includes(location.pathname)
            ) {
              return true;
            }
          }
          return false;
        }}
      />
    </>
  );
};

export default AddProduct;
